<script>
import paginateMixin from "@/mixins/PaginateMixin";
import citasService from "@/services/citasService";
import DataGrid from "@/components/common/utilities/DataGrid/DataGrid.vue";
import dayjs from "dayjs";
import ModalOrdenTrabajo from "@/views/historias/base/baseOrdenTrabajo/modalOrdenTrabajo.vue";
import ordenTrabajoService from "@/services/ordenTrabajoService";
import Toast from "@/components/common/utilities/toast";
import PageHeaderCompact from "@/components/layouts/content/page-header-compact";
export default {
  components: { ModalOrdenTrabajo, DataGrid, PageHeaderCompact },
  mixins: [paginateMixin(citasService)],
  created() {
    this.pagination.params.appointmentType = this.$route.params.appointmentType;
    this.index();
    // interval to refresh data
    this.interval = setInterval(() => {
      this.index();
    }, 20000);
  },
  data() {
    return {
      interval: null,
      appointmentType: "",
      appointments: [],
      headers: [
        "#",
        "Fecha",
        "Hora",
        "Usuario",
        "Sede",
        "Profesional",
        "Tipo Cita",
        "Estado",
        "",
      ],
      pagination: {
        params: {
          appointmentType: "",
          fecha: dayjs().format("YYYY-MM-DD"),
          estado: ["confirmada"],
        },
      },
    };
  },
  methods: {
    mapAppointmentState(state) {
      return {
        asignada: {
          rowClass: "",
          badgeClass: "text-muted",
          badgeIcon: "fa fa-circle fa-fw",
        },
        confirmada: {
          rowClass: "border-left-success border-left-lg",
          badgeClass: "text-success",
          badgeIcon: "fa fa-check-double fa-fw",
        },
        atendida: {
          rowClass: "border-left-secondary border-left-lg",
          badgeClass: "text-secondary",
          badgeIcon: "fas fa-stethoscope fa-fw",
        },
        cancelada: {
          rowClass: "border-left-danger border-left-lg",
          badgeClass: "text-danger",
          badgeIcon: "fas fa-times fa-fw",
        },
        inasistente: {
          rowClass: "border-left-warning border-left-lg",
          badgeClass: "text-warning",
          badgeIcon: "fas fa-exclamation-circle fa-fw",
        },
        desistida: {
          rowClass: "border-left-orange border-left-lg",
          badgeClass: "text-orange",
          badgeIcon: "fas fa-exclamation-circle fa-fw",
        },
      }[state];
    },
    openWorkOrderModal(id_usuario, id_cita) {
      this.$refs.modalOrdenTrabajo.open(id_usuario, id_cita);
    },
    edit(id) {
      this.$refs.modalOrdenTrabajo.edit(id);
    },
    async handleSaved($event) {
      await citasService.atendida($event.id_cita);
      this.index();
      console.log($event);
    },
    async printTicket(id_orden_trabajo) {
      try {
        this.LoaderSpinnerShow();
        //window.open(await ordenTrabajoService.printTicket(id_orden_trabajo),'_blank', 'left=100,top=100,width=500,height=500');
        const pdfUrl = await ordenTrabajoService.printTicket(id_orden_trabajo);
        const zoomedPdfUrl = `${pdfUrl}#zoom=150`;
        window.open(
          zoomedPdfUrl,
          "_blank",
          "left=100,top=100,width=500,height=500"
        );
        this.LoaderSpinnerHide();
      } catch (e) {
        this.LoaderSpinnerHide();
        console.error(e);
        Toast.fire({
          icon: "error",
          title: "Ocurrio un error al generar el ticket",
        });
      }
    },
  
  },
  computed: {
    citas: function() {
      return this.pagination.data.map((cita) => {
        return {
          citaId: cita.id,
          id: `${cita.id}`.padStart(4, "0"),
          id_usuario: cita.usuario.id,
          edad: `${cita.usuario.years}`,
          documento: `${cita.usuario.tipo_documento.codigo} ${cita.usuario.documento}`,
          usuario: `${cita.usuario.nombre_1} ${cita.usuario.nombre_2 || ""} ${
            cita.usuario.apellido_1
          } ${cita.usuario.apellido_2 || ""}`.toUpperCase(),
          sede: `${cita.agenda.sede.NOMBRE_SEDE}`.toUpperCase(),
          estado: `${cita.estado}`,
          fecha: cita.fecha_cita,
          profesional: `${cita.agenda.professional.name}`.toUpperCase(),
          nombreTipoCita: `${cita.tipo_cita.nombre}`.toUpperCase(),
          tipoCita: cita.tipo_cita,
          facturas: cita.factura_count,
          hora_inicio: dayjs(cita.fecha_cita + " " + cita.hora_inicio).format(
            "YYYY-MM-DD HH:mm:ss"
          ),
          hora: `${dayjs(cita.fecha_cita + " " + cita.hora_inicio).format(
            "hh:mm A"
          )} - ${dayjs(cita.fecha_cita + " " + cita.hora_fin).format(
            "hh:mm A"
          )}`,
          isEnabled: dayjs(cita.fecha_cita + " " + cita.hora_inicio).format(
            "YYYY-MM-DD HH:mm:ss"
          ),
          countWorkOrders: cita.ordenes_trabajo.length,
          workOrderId:
            cita.ordenes_trabajo.length > 0 ? cita.ordenes_trabajo[0].id : null,
          workOrderInfo:
            cita.ordenes_trabajo.length > 0 ? cita.ordenes_trabajo[0] : null,
        };
      });
    },
  },
  onDestroy() {
    clearInterval(this.interval);
  },
};
</script>

<template>
  <main>
    <!-- HEADER SECTION -->
      <page-header-compact>
          <template #icon>
            <i class="fas fa-flask text-white"></i>
          </template>
            Turnos de Laboratorio
      </page-header-compact>
    <div class="container-fluid px-4 mt-2">
      

      <!-- FILTERS SECTION -->
      <div class="row mb-4">
        <div class="col-12">
          <div class="card border-0 shadow-sm">
            <div class="card-body p-4">
              <div class="row align-items-center">
                <div class="col-lg-4 col-md-5">
                  <div class="form-group mb-lg-0">
                    <label class="form-label">Filtrar por Fecha</label>
                    <div class="input-group">
                      <input
                        v-model="pagination.params.fecha"
                        class="form-control form-control-sm"
                        type="date"
                      />
                      <div class="">
                        <button
                          class="btn btn-primary btn-sm px-6 mx-2"
                          @click="search()"
                        >
                          <i class="fa fa-search mr-2"></i> Buscar
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-8 col-md-7 d-flex align-items-center justify-content-lg-end mt-3 mt-md-0">
                  <div class="d-flex align-items-center bg-light p-2 rounded-lg px-3">
                    <span class="small font-weight-bold text-muted mr-3">Estados:</span>
                    <div class="custom-control custom-checkbox custom-control-inline mr-4">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="confirmada"
                        value="confirmada"
                        v-model="pagination.params.estado"
                      />
                      <label class="custom-control-label font-weight-bold text-dark cursor-pointer" for="confirmada">Confirmada</label>
                    </div>
                    <div class="custom-control custom-checkbox custom-control-inline">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="atendida"
                        value="atendida"
                        v-model="pagination.params.estado"
                      />
                      <label class="custom-control-label font-weight-bold text-dark cursor-pointer" for="atendida">Atendida</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- APPOINTMENTS LIST -->
       <div class="card">
         <div class="card-body">

    
      <data-grid :data="pagination" :search-box="true" @search="search">
        <template #grid>
          <div
            v-for="(cita, i) in citas"
            :key="`${i}_agenda_data_row`"
            class="card border shadow-none mb-3"
            :class="mapAppointmentState(cita.estado).rowClass"
          >
            <div class="card-body p-3 d-flex align-items-center justify-content-between">
              <!-- CONTENT COLUMN -->
              <div class="flex-grow-1 pr-4">
                <!-- TOP: DATE, TIME, BADGES -->
                <div class="d-flex align-items-center mb-2">
                  <div class="d-flex align-items-center">
                    <i class="far fa-calendar-alt mr-2 text-gray-700"></i>
                    <span class="font-weight-bold text-gray-700 mr-2">{{ cita.fecha | formatDate }}</span>
                    <span class="text-muted mr-2">|</span>
                    <span class="font-weight-bold text-gray-700">{{ cita.hora }}</span>
                  </div>
                  
                  <span class="badge badge-light badge-marketing px-2 py-1 mx-3 text-uppercase font-weight-bold" style="font-size: 10px; border-radius: 4px; letter-spacing: 0.3px;">
                    {{ cita.nombreTipoCita }}
                  </span>
                  
                  <span :class="mapAppointmentState(cita.estado).badgeClass" class="px-2 py-1 text-xs font-weight-bold shadow-none">
                    <i class="fas fa-check-circle mr-1"></i>
                    {{ `${cita.estado}`.toUpperCase() }}
                  </span>

                  <button
                  v-if="cita.countWorkOrders > 0"
                  class="btn btn-light btn-xs border-0 mr-3 d-flex align-items-center px-3 shadow-none"
                  title="Imprimir Ticket"
                  @click="printTicket(cita.workOrderId)"
                >
                  <i class="fas fa-flask text-primary mr-2"></i>
                  <span class="text-primary font-weight-500" style="font-size: 0.85rem; letter-spacing: 0.5px;">
                    {{ cita.workOrderInfo.toma_muestra }}
                  </span>
                </button>
                </div>
                
                <!-- MIDDLE: PATIENT -->
                <div class="d-flex align-items-center justify-content-between">
                  <div class="d-flex align-items-start">
                    <div class="mr-3 pt-1">
                      <i class="far fa-user text-dark fa-lg"></i>
                    </div>
                    <div>
                      <h6 class="mb-1 font-weight-bold text-dark" style="font-size: 1rem;">
                        ({{ cita.documento }}) {{ cita.usuario }}
                      </h6>
                      <div class="small text-gray-500 font-weight-bold">
                        {{ cita.edad }} Años
                      </div>
                    </div>
                  </div>
                  
                  <!-- Results Status -->
                  <div v-if="cita.countWorkOrders > 0 && cita.workOrderInfo.resultado" class="text-right">
                    <span class="badge badge-success-soft  px-2 py-1" style="font-size: 0.7rem;">
                      <i class="fas fa-check-circle mr-1"></i> RESULTADOS REGISTRADOS
                    </span>
                  </div>
                </div>
              </div>

              <!-- ACTIONS COLUMN -->
              <div class="d-flex align-items-center">

                <!-- Edit Order -->
                <button
                  v-if="cita.countWorkOrders > 0"
                  class="btn btn-light btn-sm border mr-2 text-secondary shadow-none"
                  title="Editar Orden"
                  @click="edit(cita.workOrderInfo.id)"
                >
                  <i class="fas fa-edit text-secondary fa-fw"></i> Editar Orden
                </button>

                <!-- Register Results -->
                <router-link
                  v-if="cita.countWorkOrders > 0"
                  class="btn btn-sm btn-light border shadow-none text-primary"
                  title="Registrar Resultados"
                  target="_blank"
                  :to="{
                    name: 'resultados.laboratorio.create',
                    params: { workOrderId: cita.workOrderId },
                    query: { orderDate: cita.fecha },
                  }"
                >
                  <i class="fas fa-vials text-primary fa-fw"></i> Registrar Resultados
                </router-link>
                
                <!-- New Order -->
                <button
                  v-if="cita.estado === 'confirmada' && cita.countWorkOrders === 0"
                  class="btn btn-sm btn-white border shadow-none"
                  title="Nueva Orden"
                  @click="openWorkOrderModal(cita.id_usuario, cita.citaId)"
                >
                  <i class="fas fa-plus text-gray-700 fa-fw"></i> Nueva Orden
                </button>
              </div>
            </div>
            <div class="card-footer p-0 bg-gray-50">
               <div class="row no-gutters align-items-center mx-2 mt-1">
                <div class="col-auto d-flex align-items-center mr-4">
                  
                  <span class="font-weight-bold text-gray-600 text-size"> <i class="fa fa-user-md text-muted mr-2"></i>{{ cita.profesional }}</span>
                </div>
                <div class="col-auto d-flex align-items-center">
                  
                  <span class="font-weight-bold text-gray-600 text-size"><i class="fas fa-map-marked-alt text-muted mr-2 "></i> {{ cita.sede }}</span>
                </div>
              </div>
            </div>
          </div>
        </template>
      </data-grid>
       </div>
       </div>
    </div>
    
    <modal-orden-trabajo
      ref="modalOrdenTrabajo"
      v-on:saved="handleSaved"
      v-on:ticket="printTicket"
    ></modal-orden-trabajo>
  </main>
</template>
<style scoped>
.text-size {
  font-size: 0.7rem;
}
.badge-success-soft {
  background-color: #dcfce7;
  color: #166534;
  border-radius: 6px;
}
</style>